// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"8a26e201","703":"e5a0fdc8"}[chunkId] + ".chunk.js";
};